// @flow
import { isArray } from "lodash";

export const QUERY_PARAMS = "QUERY_PARAMS";
export const BODY_JSON = "BODY_JSON";
export const BLOB_DATA = "BLOB_DATA";

type Options = any;

export const hasQuery = (url: string): boolean => url.indexOf("?") >= 0;

export const queryString = (object: {[keys: string]: any} = {}) => (Object.keys(object).length ?
  `?${Object.keys(object).map(key =>
    [key, typeof (object[key]) !== "object" ? object[key] : JSON.stringify(object[key])]
      .map(encodeURIComponent).join("=")).join("&")}` : "");

export const TRANSPORTS = {
  [QUERY_PARAMS]: (config: Options) => {
    const { url, data, ...rest } = config;
    const query = queryString(data);

    return {
      ...rest,
      url: url + (!hasQuery(url) ? query :
        query && `&${query.slice(1, query.length)}`)
    };
  },
  [BODY_JSON]: (config: Options) => {
    const { headers, data, ...rest } = config;

    return {
      ...rest,
      headers: {
        "Content-Type": "application/json",
        ...headers
      },
      data: JSON.stringify(isArray(data) ? [...data] : { ...data })
    };
  },
  [BLOB_DATA]: (config: Options) => {
    let blob = new FormData();
    const { data, ...rest } = config;
    const body = { ...data };

    return {
      ...rest,
      data: Object.keys(body).forEach((field) => {
        blob = body[field] instanceof Blob
          ? blob.append(field, body[field], body[field].name)
          : blob.append(`data[${field}]`, body[field]);
      })
    };
  }
};



// WEBPACK FOOTER //
// ./src/utils/http/transports.js